import Vue from 'vue'
import VueNVD3 from 'vue-nvd3'
import Grid from 'vue-js-grid'

Vue.use(VueNVD3)
Vue.use(Grid)

export default {
}



// WEBPACK FOOTER //
// ./src/utils/chart.js